import React from 'react'
import { Skeleton, SkeletonText, Stack } from "@chakra-ui/react"

export default function BlogSkeleton() {
    return (
        [1, 2, 3, 4].map(() => <Stack className="col-lg-6 col-md-6 col-sm-6" width="100%" mb={5}>
            <Skeleton height="40vh" width="100%"  />
            <SkeletonText mt="4" noOfLines={2} spacing="3"  />
        </Stack>
    ))
}
